'use client';

import Award from '@/components/Award/Award';
import classes from '@/components/Award/Award.module.scss';
import AwardsComponent from '@/components/Awards/Awards';
import { StoryblokImage } from '@/components/customFields/StoryblokImage';
import { resolveStory } from '@/helper/utils';
import type { ComponentAwardsStoryblok, EntityAwardStoryblok } from '@/types/component-types-sb';
import { storyblokEditable } from '@storyblok/react/rsc';

const Awards: React.FC<{ blok: ComponentAwardsStoryblok }> = ({ blok }) => (
  <AwardsComponent {...storyblokEditable(blok)}>
    {blok.awards?.map((awardStory) => {
      const award = resolveStory<EntityAwardStoryblok>(awardStory);
      if (!award?.content.image) {
        return;
      }
      return (
        <Award
          key={award?.uuid}
          image={<StoryblokImage className={classes.awardImage} image={award?.content.image} />}
          subtitle={award?.content.subtitle}
          description={award?.content.description}
        />
      );
    })}
  </AwardsComponent>
);
export default Awards;
